// import Dialog from "~/components/molecules/Dialog"
import { inject, Observer } from "mobx-react"
import { WithRouterProps } from "next/dist/client/with-router"
import Head from "next/head"
import { withRouter } from "next/router"
import React from "react"

import CourseApplyDoneModal from "~/components/organisms/CourseApplyDoneModal"
import CourseInputPersonalDataModal from "~/components/organisms/CourseInputPersonalDataModal"
import CourseSchduleSelectModal from "~/components/organisms/CourseSchduleSelectModal"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import Background from "~/components/organisms/course-detail/Background"
import Consultation from "~/components/organisms/course-detail/Consultation"
import Curriculum from "~/components/organisms/course-detail/Curriculum"
import MainVisual from "~/components/organisms/course-detail/MainVisual"
import Price from "~/components/organisms/course-detail/Price"
import PromoteArea from "~/components/organisms/course-detail/PromoteArea"
import Teacher from "~/components/organisms/course-detail/Teacher"
import { Course } from "~/entities/Course"
import { TmpUserInfo } from "~/entities/User"
import { staticPath } from "~/services/helper"
import ApplicationStore from "~/stores/ApplicationStore"
import RootStore from "~/stores/RootStore"
import UiStore from "~/stores/UiStore"
import UserStore from "~/stores/UserStore"

interface Props {
  applicationStore: ApplicationStore
  course: Course
  uiStore: UiStore
  userStore: UserStore
}

interface State {
  selectedScheduleValues: string[]
  isLoading: boolean
  tmpUserInfo: TmpUserInfo
}

@inject("applicationStore", "uiStore", "userStore")
class DataScienceCourse extends React.Component<WithRouterProps & Props, State> {
  static async getInitialProps({ initialStoreData }: { initialStoreData: RootStore }) {
    const { courseStore } = initialStoreData
    const course = await courseStore.fetchById(5)
    return { course }
  }

  state = {
    selectedScheduleValues: [],
    isLoading: false,
    tmpUserInfo: {
      name: null,
      phoneNumber: null,
    },
  }

  constructor(props: WithRouterProps & Props) {
    super(props)
    const { uiStore } = props
    switch (props.router.query.openModal) {
      case "selectSchedule":
        uiStore.toggleCourseSchduleSelectModal()
        break
      case "confirmApply":
        uiStore.toggleConfirmCourseApplyModal()
        break
      case "applyComplete":
        uiStore.toggleCompleteApplyCourseModal()
        break
    }
  }

  render() {
    const { applicationStore, course, uiStore, userStore } = this.props
    const { selectedScheduleValues, isLoading, tmpUserInfo } = this.state
    const handleSelectSchedule = (schedules: string[]) => {
      this.setState({
        selectedScheduleValues: schedules,
      })
    }

    const toggleLoading = () => {
      this.setState({
        isLoading: !this.state.isLoading,
      })
    }

    const updateTmpUserInfo = (values: TmpUserInfo) => {
      this.setState({
        tmpUserInfo: values,
      })
    }

    const mainActionForSchduleSelectModal = async () => {
      toggleLoading()
      selectedScheduleValues.sort()
      if (userStore.authed) {
        await applicationStore.courseConsultationApply(5, selectedScheduleValues.sort())
      } else {
        await applicationStore.courseConsultationApplyByGuest(5, tmpUserInfo, selectedScheduleValues.sort())
      }
      uiStore.toggleCourseSchduleSelectModal()
      uiStore.toggleCompleteApplyCourseModal()
      toggleLoading()
    }

    return (
      <>
        <Head>
          <title>マーケティング講座 | Infra（インフラ）</title>
          <meta name="description" content={course.description} />
          <meta
            property="og:image"
            content={`${process.env.APP_HOST + staticPath("/static/images/course/marketing/ogp.png")}`}
          />
          <meta name="og:title" content="マーケティング講座 | Infra（インフラ）" />
          <meta
            name="og:description"
            content="ITを駆使したデジタルマーケティングを体系的に学びます。講座の後半では実際に企業の課題に対して改善提案や広告プランニングを行い実務レベルを目指します"
          />
          <meta
            name="og:image"
            content={process.env.APP_HOST + staticPath("/static/images/course/marketing/ogp.png")}
          />
        </Head>
        <Header logoType="Courses" showTab />
        <MainVisual
          mSrcPc={staticPath("/static/images/course/marketing/mv.png")}
          mSrcSp={staticPath("/static/images/course/marketing/mv-sp.png")}
          typoPath={staticPath("/static/images/course/marketing/typo.svg")}
          heading="マーケティング講座"
          description="ITを駆使したデジタルマーケティングを体系的に学びます。講座の後半では実際に企業の課題に対して改善提案や広告プランニングを行い実務レベルを目指します"
          courseLineUrl={course.lineUrl}
          disabled={true}
        />
        <Background
          message={`マーケターは「モノやサービスを認知させ、集客し、購買や登録などへと繋げる」役割を担います。
          これまでテレビやラジオなどマス（集団）に行っていたマーケティング手法が主流でしたがインターネットやSNSの普及によって、より細かく属性分けされた集団や個人へアプローチする手法が盛んになっています。
          またWebサイトの閲覧履歴や位置情報など収集された消費者データの分析結果を基に、商品開発や広告・宣伝に反映させられる "デジタルマーケティング" のスキルが求められています。

          本講座では「デジタルマーケティング」を体系的に学び、マーケターとしての一歩を踏み出せるよう、実際に現場で活躍するプロのマーケターから必要な知識を学びます。
          `}
        />
        <PromoteArea
          bgPath={staticPath("/static/images/course/marketing/mv.png")}
          courseName="マーケティング講座"
          courseLineUrl={course.lineUrl}
          disabled={true}
        />
        <Teacher
          items={[
            {
              img: staticPath("/static/images/course/marketing/teacher-1.jpg"),
              name: "三宅 晋太郎",
              position: "gens,Inc代表",
              introduction:
                "マーケティングリサーチ会社→フリーランス→ランサーズ株式会社でデジタルマーケティングに従事。インハウスマーケターとして運用型広告などのプロモーション企画から、LPO/EFOからサービス全体の分析改善まで担当。現職では複数のベンチャー企業のマーケティング戦略を支援。",
            },
          ]}
        />
        <PromoteArea
          bgPath={staticPath("/static/images/course/marketing/mv.png")}
          courseName="マーケティング講座"
          courseLineUrl={course.lineUrl}
          disabled={true}
        />
        <Curriculum
          heading="プロのスキルを2ヶ月に凝縮（オンライン完結）"
          period="第2期 2020年9月中旬より開講予定"
          curriculumItems={[
            {
              periodImgPc: staticPath("/static/images/course/period-2month-pc.svg"),
              periodImgSp: staticPath("/static/images/course/period-2month-sp.svg"),
              heading: "全10回",
              date: "",
              caption: "1. イントロダクション",
              body: "デジタルマーケティングの概観、MECEやSWOT分析などの著名なフレームワーク、KPIの設定手法について学びます。",
            },
            {
              caption: "2. リサーチ・顧客理解",
              body: "インタビュー、アンケート、ユーザーテストといったリサーチ手法と、ペルソナ・カスタマージャーニーの作り方を学びます。",
            },
            {
              caption: "3〜4. デジタル広告",
              body: "デジタル広告の仕組みを説明し、リスティング広告、SNS広告、ディスプレイ広告、動画広告など各広告の運用方法を学びます。",
            },
            {
              caption: "5. ワークショップ（デジタル広告）",
              body: "実在サービスを使い、広告プランニングを通してデジタル広告への理解を深めます。",
            },
            {
              caption: "6. マーケティングツール",
              body: "Google Analyticsなど、カイゼン・分析・運用に不可欠なツールの使い方を学びます。",
            },
            {
              caption: "7. カイゼン",
              body: "どのようにカイゼン目処を立てるか等、広告クリエイティブやLP（ランディングページ）のカイゼンの考え方を学びます。EFO（エントリーフォーム最適化）にも触れます。",
            },
            {
              caption: "8. ワークショップ（カイゼン）",
              body: "実在するページを用いて、クリエイティブのカイゼンとLPO、EFOを行い、実践を通してカイゼン手法の理解を深めます。",
            },
            {
              caption: "9〜10. ワークショップ（広告運用）",
              body: "実際にクライアント企業の要求・課題に対してプランニング提案を行い、採択案に対して実際に予算を投下して運用し、結果のレビューや振り返りまで行います。",
            },
          ]}
          recommendItems={[
            "マーケティング職としてインターン/就職したい方",
            "IT企業で活躍するためにデジタルマーケティングの知識/スキルを身につけておきたい方",
            "デジタル広告の仕組みや運用、プランニングについて学びたい方",
            "Webサイトやサービスのデータ分析や改善の手法を学びたい方",
          ]}
        />
        <PromoteArea
          bgPath={staticPath("/static/images/course/marketing/mv.png")}
          courseName="マーケティング講座"
          courseLineUrl={course.lineUrl}
          disabled={true}
        />
        <Price
          items={[
            {
              price: 79000,
              // originalPrice: 78000,
              splitNum: 5,
            },
          ]}
        />
        <PromoteArea
          bgPath={staticPath("/static/images/course/marketing/mv.png")}
          courseName="マーケティング講座"
          courseLineUrl={course.lineUrl}
          disabled={true}
        />
        <Consultation job="マーケター" />
        <PromoteArea
          bgPath={staticPath("/static/images/course/marketing/mv.png")}
          courseName="マーケティング講座"
          courseLineUrl={course.lineUrl}
          disabled={true}
        />
        <Observer>
          {() => (
            <>
              {/* <Dialog
                open={uiStore.authPromptModalOpen}
                heading="登録またはログインが必要です"
                mainAction={{
                  label: "登録する",
                  action: () =>
                    window.open(uiStore.redirectUrlAfterAuth, "_self"),
                }}
                subAction={{
                  label: "キャンセル",
                  action: () => uiStore.toggleAuthPromptModal(),
                }}
              >
                エントリー/お気に入りを利用するためには、新規登録またはログインが必要です。
              </Dialog> */}
              {/* <Dialog
                open={uiStore.confirmCourseApplyModalOpen}
                heading="講座申し込みの確認"
                mainAction={{
                  label: "申し込む",
                  action: async () => {
                    toggleLoading()
                    uiStore.toggleConfirmCourseApplyModal()
                    uiStore.toggleCompleteApplyCourseModal()
                    // 広告CV設定のため、敢えてリロードさせる
                    location.href = `${
                      process.env.APP_HOST + location.pathname
                    }?openModal=applyComplete`
                    toggleLoading()
                  },
                  className: "gtm_course-complete-application",
                  isLoading: isLoading,
                }}
                subAction={{
                  label: "キャンセル",
                  action: () => uiStore.toggleConfirmCourseApplyModal(),
                }}
              >
                こちらの講座は<PaidAlert>有料</PaidAlert>となります。
                <br />
                申し込みを確定してよろしいですか？
              </Dialog> */}
              <CourseInputPersonalDataModal
                open={uiStore.authPromptModalOpen}
                close={() => uiStore.toggleAuthPromptModal()}
                updateTmpUserInfo={updateTmpUserInfo}
                mainAction={() => {
                  uiStore.toggleAuthPromptModal()
                  uiStore.toggleCourseSchduleSelectModal()
                }}
              />
              <CourseSchduleSelectModal
                open={uiStore.courseSchduleSelectModalOpen}
                selectedScheduleValues={selectedScheduleValues}
                onSelectSchedule={handleSelectSchedule}
                mainAction={mainActionForSchduleSelectModal}
                subAction={() => uiStore.toggleCourseSchduleSelectModal()}
                isLoading={isLoading}
              />
              <CourseApplyDoneModal
                open={uiStore.completeApplyCourseModalOpen}
                close={() => uiStore.toggleCompleteApplyCourseModal()}
                addFriend={() => window.open(course.lineUrl)}
                lineQrImageUrl={course.lineQrImageUrl}
              />
            </>
          )}
        </Observer>
        <Footer />
      </>
    )
  }
}

export default withRouter(DataScienceCourse)
